import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vant/lib/index.css";
import "./libs/rem.js";
import "./assets/scss/reset.scss"; // 初始化
import "./assets/scss/main.scss"; // 复用样式
import "./assets/scss/vant.scss"; // vant修改样式
import axios from "axios";
import VueAxios from "vue-axios";
import { types } from "@/store/user";
import { getUserId, isNewUserForVI,getStoreInfoApi } from "@/libs/api";
import _ from "lodash";
// 引入公共方法
import { pubMethods } from "@/mixins/index";
import { browser, uleUrl, uleCdn, isIncludeJs, isWhiteList, getPosition, getCookie, setClientType } from "@/libs/common.js";
import VueCookies from "vue-cookies";
import moment from "moment";
import VueClipboard from "vue-clipboard2";
import postingApp from "./libs/posting-app.js";
import VueCropper from "vue-cropper";
// filters
import * as filters from "./libs/filter";
import VConsole from "vconsole";
if (process.env.VUE_APP_MODE != "production") {
  const vConsole = new VConsole();
  Vue.use(vConsole);
}
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
VueClipboard.config.autoSetContainer = true; // add this
Vue.config.productionTip = false;
Vue.prototype.$browser = browser;
Vue.prototype.$axios = axios;
Vue.prototype.$uleUrl = uleUrl;
Vue.prototype.$uleCdn = uleCdn;
Vue.prototype.$postingApp = postingApp;
Vue.prototype.$moment = moment; //赋值使用
Vue.prototype._ = _;
Vue.use(VueAxios, axios);
Vue.mixin(pubMethods);
Vue.use(VueCookies);
Vue.use(VueClipboard);
Vue.use(VueCropper);
// Vue.config.ignoredElements = ['wx-open-launch-weapp'];
import {
  Picker,
  Step,
  Steps,
  Col,
  Row,
  Panel,
  Overlay,
  Dialog,
  SwipeCell,
  List,
  AddressList,
  AddressEdit,
  RadioGroup,
  Radio,
  Sticky,
  Button,
  Collapse,
  CollapseItem,
  Search,
  TreeSelect,
  Card,
  Icon,
  Popup,
  Divider,
  Tabbar,
  TabbarItem,
  Toast,
  Grid,
  GridItem,
  Image,
  Tab,
  Tabs,
  NavBar,
  Swipe,
  SwipeItem,
  Lazyload,
  Tag,
  CountDown,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Stepper,
  NoticeBar,
  Form,
  Field,
  Checkbox,
  CheckboxGroup,
  SubmitBar,
  Skeleton,
  Cell,
  CellGroup,
  CouponCell,
  CouponList,
  Loading,
  Rate,
  Uploader,
  Area,
  Empty,
  pullRefresh,
  ImagePreview,
  Calendar,
  ActionSheet
} from "vant";
[
  Picker,
  Step,
  Steps,
  Col,
  Row,
  Panel,
  Overlay,
  Dialog,
  SwipeCell,
  List,
  AddressList,
  AddressEdit,
  RadioGroup,
  Radio,
  Sticky,
  Button,
  Collapse,
  CollapseItem,
  Search,
  TreeSelect,
  Card,
  Icon,
  Popup,
  Divider,
  Tabbar,
  TabbarItem,
  Toast,
  Grid,
  GridItem,
  Image,
  Tab,
  Tabs,
  NavBar,
  Swipe,
  SwipeItem,
  Lazyload,
  Tag,
  CountDown,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Stepper,
  NoticeBar,
  Form,
  Field,
  Checkbox,
  CheckboxGroup,
  SubmitBar,
  Skeleton,
  Cell,
  CellGroup,
  CouponCell,
  CouponList,
  Loading,
  Rate,
  Uploader,
  Area,
  Empty,
  pullRefresh,
  ImagePreview,
  Calendar,
  ActionSheet
].forEach((item) => {
  Vue.use(item);
});

//白名单
const whiteList = [
  "login",
  "retrieve",
  "home",
  "freshHome",
  "itemPage",
  "couponTurn",
  "itemComment",
  "positionLost",
  "pickupList",
  "pickupSearch",
  "pickupLogistics",
  "pickupDetail",
  "join",
  "new",
  "downapp",
  "store",
  "chainsDetail",
  "orgInfo",
  "indexPick",
  "userCenter",
  "categoryList",
  "cartList",
  "searchList",
  "returnGoodsList",
  "returnGoodsOrderList",
  "returnGoodsPickingList",
  "returnGoodsPhotoList",
  "group",
  "editGroup",
  "copy",
  "ylsqCopy",
  "ylsqGroup",
  "ylsqEditGroup",
  "salesData",
  "income",
  "customer",
  "customerList",
  "customerSee",
  "schoolList",
  "userConpon",
  "chainsNew",
  "performance"
];
// 路由守卫
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    // console.log("to=====", to);
    if (to.path == "/order/orderList") {
      document.title = "";
    } else {
      document.title = to.meta.title;
    }
  }
  // cookies存入client_type
  setClientType(to);
  // 获取storeId
  if (store.getters[types.STORE_ID] === "") {
    if(browser().ulemax){
      console.log('4合111')
      let usrOnlyid = getCookie("usrOnlyid")||'';
      console.log('usrOnlyid====',usrOnlyid)
      store.commit(types.STORE_ID, usrOnlyid);
    }else{
      getUserId("jsonCallBack").then((res) => {
        if (res.useronlyid) {
          store.commit(types.STORE_ID, res.useronlyid);
        }
      });
    }
  } else {
    console.log("未登录");
    // isNewUserForVI().then((res) => {
    //   if (res.code == "0000") {
    //     if (res.data.new) {
    //       store.commit(types.USER_CUSTOME, 1); // 新人标识是1
    //     } else {
    //       store.commit(types.USER_CUSTOME, 2); // 杀熟2
    //     }
    //   }
    // });
  }
  // vi页存入返回标识
  if (to.name === "itemPage") {
    localStorage.setItem("pageBackHref", from.path);
  }
  if (to.name === "positionLost") {
    localStorage.setItem("backHref", from.path);
  }
  // 不在路由中，跳转404页
  if (to.matched.length === 0) {
    next("/others/pageLost");
  }
  // 需要定位的页面   优鲜详情 Z3  p3类型不需要定位
  console.log('to.name=====1',to.name)
  console.log('to.browser().ulemax=====1',browser().ulemax)
  if (to.name === "home" || to.name === "freshHome" || to.name === "itemPage" || to.name === "indexPick" || to.name === "chainsDetail" || to.name === "performance" || to.name === 'cartList' || to.name ==='categoryList') {
    if((to.name == 'cartList' || to.name == 'categoryList') && browser().ulemax){
      console.log('4合1购物车列表页或者分类')
      getPosition(to, next, whiteList, Toast, Dialog);
    }else{
      getPosition(to, next, whiteList, Toast, Dialog);
    }
  } else {
    isWhiteList(to, next, whiteList);
  }
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
